module.exports = __webpack_public_path__ + "static/media/arrow-right-lilas.3c821927.svg";